import { RouteConfig } from "vue-router";

export const RNotificationsTemplate: RouteConfig = {
  path: ":id(\\d+)",
  name: "NotificationsTemplate",
  component: () =>
    import(
      /* webpackChunkName: "notifications-template" */
      "./VNotificationsTemplate.vue"
    ),
  meta: {
    title: "Back",
    backLink: "/notifications",
  },
};
